import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminFinishRechargeCreditComponent from "../../../components/Admin/agencies/AdminFinishRechargeCreditComponent";

const AdminFinishRechargeCreditPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin');
    }

    return <AdminFinishRechargeCreditComponent
        paymentId={ params.paymentId }
        shouldRedirect={ () => redirect() }
    />;
}

export default AdminFinishRechargeCreditPage;
